export default "__VITE_ASSET__CifkhrZp__"